<template>
    <article class="pf-search">
        <div class="pf-search__trigger">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.33333 3.75C5.80203 3.75 3.75 5.80203 3.75 8.33333C3.75 10.8646 5.80203 12.9167 8.33333 12.9167C9.566 12.9167 10.685 12.4301 11.5087 11.6384C11.5274 11.6146 11.5477 11.5916 11.5697 11.5697C11.5916 11.5477 11.6146 11.5274 11.6384 11.5087C12.4301 10.685 12.9167 9.566 12.9167 8.33333C12.9167 5.80203 10.8646 3.75 8.33333 3.75ZM13.1326 12.0719C13.9373 11.0405 14.4167 9.74289 14.4167 8.33333C14.4167 4.9736 11.6931 2.25 8.33333 2.25C4.9736 2.25 2.25 4.9736 2.25 8.33333C2.25 11.6931 4.9736 14.4167 8.33333 14.4167C9.74289 14.4167 11.0405 13.9373 12.0719 13.1326L14.4697 15.5303C14.7626 15.8232 15.2374 15.8232 15.5303 15.5303C15.8232 15.2374 15.8232 14.7626 15.5303 14.4697L13.1326 12.0719Z"
                    fill="#252628"/>
            </svg>
            <input
                class="pf-search__field"
                :class="{hasValue: searchText.length !== 0}"
                type="text"
                :name="name"
                id="filterSearch"
                v-model="searchText"
                :placeholder="placeholder"
                @input="checkSearchValue"
                @keydown.enter="onSubmit"
                @change="searchHandler"
                autocomplete="off"/>
            <button
                v-if="clearButton"
                class="pf-search__clear clear-btn"
                type="button"
                @click.prevent.stop="clearSearchField"></button>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'Search',
        data() {
            return {
                searchResultItems: null,
                searchText: '',
                clearButton: false,
                name: 'search'
            }
        },
        props: {
            placeholder: {
                type: String,
                default: 'Поиск',
            },
            onloadValue: {
                type: String,
                default: ''
            }
        },
        methods: {
            onSubmit () {
                this.$emit('searchDone', this.name, this.searchText)
            },

            checkSearchValue () {
                if (this.searchText.length !== 0) {
                    this.clearButton = true
                    return
                }

                this.clearButton = false
            },

            searchHandler () {
                this.checkSearchValue()
                this.onSubmit()
            },

            clearSearchField () {
                this.searchText = ''
                this.checkSearchValue()
                this.$emit('searchDone', this.name, this.searchText)
            }
        },
        created() {
            if (this.onloadValue) {
                this.searchText = this.onloadValue
                this.checkSearchValue()
            }
        }
    }
</script>